import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import React from 'react';

const Button = (props: LoadingButtonProps): JSX.Element => {
  return <LoadingButton variant="contained" {...props} />;
};

export default Button;
